export default __webpack_public_path__ + "static/media/dnd-grip.008b705b.svg";